import { render, staticRenderFns } from "./MarketCustomers.vue?vue&type=template&id=4912fe4c&"
import script from "./MarketCustomers.vue?vue&type=script&lang=js&"
export * from "./MarketCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports